import React from 'react';
import { Link } from 'react-router-dom';

import { TextOverflow, StyledAnchor } from './LinkOverflow.styles';

export function LinkOverflow({
    children,
    underline,
    textClassName = '',
    ...props
}: {
    children: React.ReactNode;
    underline?: boolean;
    textClassName?: string;
} & React.ComponentProps<typeof StyledAnchor>) {
    return (
        <StyledAnchor as={Link} {...props}>
            <TextOverflow
                $textDecoration={(underline && 'underline') || undefined}
                className={textClassName}
            >
                {children}
            </TextOverflow>
        </StyledAnchor>
    );
}
